import { Component, OnInit } from "@angular/core";
import { CrudService } from "src/app/Services/crud.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { PaymentPlansActions } from "src/app/ThemeOptions/store/payment-plans.actions";

import { environment } from "src/environments/environment";
import { ROLE } from "src/app/Utils/const";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";
declare var Razorpay: any;

@Component({
  selector: "app-payment-plans",
  templateUrl: "./payment-plans.component.html",
  standalone: false,
})
export class PaymentPlansComponent implements OnInit {
  data = [];
  isLoading: boolean = false;
  isLoggedIn;

  constructor(
    private crudService: CrudService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router: Router,
    private paymentPlansActions: PaymentPlansActions,
    private route: ActivatedRoute,
    private logedInUserService: LogedInUserService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    let access_token = localStorage.getItem("access_token");
    if (access_token) {
      this.isLoggedIn = true;
      this.checkAdmin();
    }
  }
  projectId;
  ngOnInit() {
    // console.log("payment plans called");
    this.isLoading = true;
    this.fetchData();

    this.projectId =
      this.route.snapshot.queryParamMap.get("projectManagementId") || "";

    // console.log("signin value", this.isLoggedIn);
  }

  selectPlan(plan) {
    if (this.isLoggedIn) {
      this.createLicenseHistoryEntry(plan);
    } else {
      this.paymentPlansActions.selectPlan(plan);
      this.router.navigate(["/login"]);
    }
  }

  checkAdmin() {
    var self = this;
    self.logedInUserService.get(function (response) {
      if (response && response.companyId) {
        if (response.roleId) {
          const { Administrator = null } =
            ROLE.find((role) => role.Administrator) || {};
          const { ReadOnly = null } = ROLE.find((role) => role.ReadOnly) || {};

          if (
            Administrator &&
            ReadOnly &&
            !response.roleId.includes(Administrator)
          ) {
            self.onLogout();
          }
          if (Administrator && ReadOnly && response.roleId.includes(ReadOnly)) {
            self.onLogout();
          }
        }
      }
    });
  }

  onLogout() {
    let self = this;
    self.crudService.post(
      { accessToken: localStorage.getItem("access_token") },
      function (response) {},
      "userManagements/logout?access_token=" +
        localStorage.getItem("access_token")
    );
    localStorage.removeItem("access_token");
    self.router.navigate(["/"]);
  }

  createLicenseHistoryEntry(selectedPlan) {
    var licenseHistoryEntry = {
      licenseModuleId: selectedPlan.id,
      transactionId: null,
      orderId: null,
      razor_pay_response: null,
      projectManagementId: this.projectId,
      /*  validFrom: null,
      validUpto: null, */
    };
    var amount = parseFloat(selectedPlan.totalAmount);
    if (isNaN(amount)) {
      console.error("The applicableAmount is not a valid number.");
      amount = 0;
    } else {
      amount = Math.round(amount * 100);
    }
    if (selectedPlan.paymentFrequency != "free") {
      this.crudService.post(
        { amount: amount },
        (order) => {
          if (!order.error) {
            const RazorpayOptions = {
              description:
                "TheAppSherpa" +
                " " +
                selectedPlan.paymentFrequency +
                " " +
                "plan payment.",
              currency: "USD",
              amount: amount,
              name: "TheAppSherpa",
              key: "rzp_live_PkhJ3SFfKZ4yqf",
              image: `${environment.appURL}/assets/images/appsherpa-icon-blue.png`,
              theme: {
                color: "#032d55",
              },
              order_id: order.id,
              modal: {
                ondismiss: () => {
                  console.log("Payment modal dismissed");
                },
              },
              handler: (response: any) => {
                licenseHistoryEntry.razor_pay_response = response;
                licenseHistoryEntry.transactionId =
                  response.razorpay_payment_id;
                licenseHistoryEntry.orderId = order.id;

                // licenseHistoryEntry.validFrom = new Date().toISOString();
                console.log(
                  "license history inside create licensehistoryentry",
                  licenseHistoryEntry
                );
                this.createLicense(licenseHistoryEntry);
              },
            };

            console.log("razorpay options here", RazorpayOptions);
            const razorpay = new Razorpay(RazorpayOptions);
            razorpay.open();

            razorpay.on("payment.failed", (response: any) => {
              console.error(response.error);
            });
          }
        },
        "licenseHistories/createOrder"
      );
    } else {
      this.createLicense(licenseHistoryEntry);
    }
  }

  createLicense(licenseHistoryEntry) {
    console.log("license history object:: Payload ", licenseHistoryEntry);
    this.crudService.post(
      licenseHistoryEntry,
      (response) => {
        console.log("response from license history", response);
        this.paymentPlansActions.selectPlan(null);
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          this.toastr.error(response.error.error.message, "Invalid Operation");
          this.router.navigate(["/page/project-license-information"]);
        } else {
          this.toastr.success("License Purchased", "Success");
          this.router.navigate(["/page/project-license-information"]);
        }
      },
      "licenseHistories"
    );
  }

  fetchData() {
    const today = new Date();
    const todayStr = today.toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

    const filter = {
      where: {
        status: true,
        validFrom: { lte: todayStr },
        validUpto: { gte: todayStr },
      },
    };
    var self = this;
    self.crudService.get(
      null,
      function (response) {
        self.isLoading = false;
        if (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            if (response.length) {
              self.data = response;
            } else {
              self.data = [];
            }
          }
        }
      },
      `licenseModules?filter=${encodeURIComponent(JSON.stringify(filter))}`
    );
  }
}
